import {Injectable} from '@angular/core';
import {ToolsService} from '../../../services/tools.service';
import {BookingErrorTypeEnum} from '../enums/booking-enums';
import {BookingResponseError} from '../types/booking-response-error';

@Injectable({
  providedIn: 'any',
})
export class BookingV2ErrorHandlerService {
  private errorMessageBuildersMap: Array<Function> = [];
  constructor(private tools: ToolsService) {
    this.buildErrorMessageBuildersMap();
  }

  public getErrorMessage(responseError: BookingResponseError): string {
    let errorMessage: string;
    if (
      !this.tools.isNil(responseError.errorType) &&
      !this.tools.isNil(this.errorMessageBuildersMap[responseError.errorType])
    ) {
      errorMessage =
        this.errorMessageBuildersMap[responseError.errorType](responseError);
    } else {
      errorMessage = this.getGenericErrorMessage(responseError);
    }
    return errorMessage;
  }

  private buildErrorMessageBuildersMap(): void {
    this.errorMessageBuildersMap[BookingErrorTypeEnum.ERROR] = (
      responseError: BookingResponseError
    ) => this.getGenericErrorMessage(responseError);
    this.errorMessageBuildersMap[BookingErrorTypeEnum.ERROR_SERVICE] = (
      responseError: BookingResponseError
    ) => BookingV2ErrorHandlerService.getServiceErrorMessage(responseError);
    this.errorMessageBuildersMap[BookingErrorTypeEnum.ERROR_VALIDATION] = (
      responseError: BookingResponseError
    ) => this.getValidationErrorMessage(responseError);
  }

  private getGenericErrorMessage(responseError: BookingResponseError): string {
    return !this.tools.isNil(responseError) &&
      !this.tools.isNil(responseError.message)
      ? responseError.message
      : 'Okänt fel har inträffat. Försök igen senare.';
  }

  private static getServiceErrorMessage(
    responseError: BookingResponseError
  ): string {
    return responseError.additionInformation.indexOf(
      'booking_no_slots_available'
    ) !== -1
      ? 'Tyvärr är denna tid inte tillgänglig. Vänligen välj en annan tid.'
      : responseError.additionInformation.indexOf('booking_patient_error') !==
        -1
      ? 'Det gick inte att registrera dina uppgifter hos kliniken. Det kan bero på att du har bokat vård hos den här kliniken tidigare med andra personuppgifter. Vänligen kontrollera att dina personuppgifter är samma som du brukar använda vid bokning. Kontakta kliniken om du behöver ytterligare hjälp.'
      : responseError.additionInformation.indexOf(
          'booking_age_validation_error'
        ) !== -1
      ? 'Denna vårdtjänst går ej att boka med din ålder. Välj en annan vårdtjänst och försök igen.'
      : responseError.message;
  }

  private getValidationErrorMessage(
    responseError: BookingResponseError
  ): string {
    let errorMessage: string = responseError.message;
    if (!this.tools.isNil(responseError.validationData)) {
      errorMessage += '<br>';
      Object.keys(responseError.validationData).forEach((key) => {
        errorMessage += responseError.validationData[key].join('<br>');
      });
    }
    return errorMessage;
  }
}
